import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  REFERRAL_FETCH,
  REFERRAL_FETCH_ONE,
  REFERRAL_LAST_FETCH,
  REFERRAL_UPDATE,
  REFERRAL_CLEAR
} from './types';

export const getReferrals = (params = [], limit = 100, options = {
  attrType: 'custom',
  columns: [
    'refCode',
    'createByApp',
    'createByAppName',
    'createdAt',
    'careGiver',
    'careGiverFirstName',
    'careGiverLastName',
    'updatedAt',
    'patCode',
    'patient',
    'patientFirstName',
    'patientLastName',
    'mapImageDoctor',
    'mapImagePatient',
    'patientBirthdate',
    'patientGender',
    'information',
    'pendingInformation',
    'drugAllergyHistory',
    'attachments',
    'patientMobile',
    'patientEmail',
    'patientNation',
    'patientAllowToShowHistory',
    'primaryHn',
    'doctor',
    'status',
    'completedAt',
    'medOrder',
    'supplyOrder',
    'acceptMedOrder',
    'confirmMedOrder',
    'type',
    'doctorNotesChiefCompliant',
    'doctorNotesConsultantionSummary',
    'doctorNotesProvisionalDiagnosis',
    'doctorNotesDoctorRecommendations',
    'doctorNotesDrugRecommendations',
    'icd10',
    'rejectAs',
    'cancelReason',
    'caseType',
    'isDemo',
    'doctorPrice',
    'payDoctor',
    'payDoctorType',
    'consultTime',
    'statusLogs',
    'payment',
    'volunteerOnly',
    'couponCode',
    'couponDescription',
    'useInNewDesign',
    'useWeb',
    'shortLinkForComplete',
    'currentFcmToken',
    'currentApnToken',
    'userRecivedCall',
    'useInNewMiniDesign',
    'patientWaitInRoom',
    'doctorWaitInRoom',
    'doctorRecivedCall',
    'createdFirstName',
    'createdLastName',
    'createdMobile',
    'patientPassportNumber',
    'createdHosName',
    'medwandDoctorUrl',
    'patientSource',
    'patientIsVerify',
    'captureScreen',
    'pharmacyName',
    'customize'
  ]
}, tpye = REFERRAL_FETCH, nextKey = '') => async dispatch => {
  let isAddMore = false;
  const newParams = [
    `limit=${limit}`,
    ...params
  ];
  let url = `referrals?${newParams.join('&')}`;

  if (options?.columns?.length > 0) {
    url += `&attrType=custom&${options.columns.map((column, key) => `attributes[${key}]=${column}`).join('&')}`;
  }
  if (nextKey !== '') {
    isAddMore = true;
    url += `&nextKey=${nextKey}`;
  }

  dispatch({ type: REFERRAL_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { REFERRAL_FETCH: true } });
  let result = [];
  await axios.get(url).then(response => {
    if (tpye === REFERRAL_LAST_FETCH) {
      const lastData = (response.data && response.data.data) || [];
      dispatch({ type: tpye, playload: { lastData, status: 'success' } });
      result = lastData;
    } else {
      const data = (response.data && response.data.data) || [];
      dispatch({
        type: tpye,
        playload: {
          data,
          status: 'success',
          isAddMore,
          nextKey: response?.data?.nextKey
        }
      });
      result = data;
    }
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_FETCH: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_FETCH: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
    result = [];
  });
  return result;
};

export const getReferralByCode = (refCode, isShowLoading = true, options = {}) => async dispatch => {
  const columns = options?.columns || [];
  let url = `referrals?code=${encodeURIComponent(refCode)}`;
  if (columns.length > 0) {
    url += `&attrType=custom&${columns.map((column, key) => `attributes[${key}]=${encodeURIComponent(column)}`).join('&')}`;
  }

  dispatch({ type: REFERRAL_CLEAR });
  dispatch({ type: IS_LOADING, status: isShowLoading, names: { REFERRAL_FETCH_ONE: isShowLoading } });
  await axios.get(url).then(response => {
    const resData = response.data;
    const data = ((resData && resData.data) || []);
    const detail = data.find(o => o.refCode === refCode);
    let status = 'success';
    if (resData.error || resData.errors || !detail) {
      status = 'error';
    }
    dispatch({ type: REFERRAL_FETCH_ONE, playload: { detail, status, message: !detail ? 'Referral not found' : undefined } });
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_FETCH_ONE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_FETCH_ONE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
    dispatch({ type: REFERRAL_FETCH_ONE, playload: { detail: undefined, status: 'error', message: 'Unable to load referral' } });
  });
};

export const referralUpdate = (refCode, dataSet, isShowLoading = true) => async dispatch => {
  if (!refCode) {
    return;
  }
  const url = `referrals/${refCode}`;

  dispatch({ type: REFERRAL_CLEAR });
  dispatch({ type: IS_LOADING, status: isShowLoading, names: { REFERRAL_UPDATE: isShowLoading } });
  await axios.put(url, dataSet).then(response => {
    const resData = response.data;
    const { message } = resData;
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: REFERRAL_UPDATE, playload: { status, message } });
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_UPDATE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: REFERRAL_UPDATE, playload: { status: 'error' } });
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_UPDATE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const referralCancel = (refCode, dataSet, isShowLoading = true) => async dispatch => {
  const url = `referrals/cancel/${refCode}`;

  dispatch({ type: REFERRAL_CLEAR });
  dispatch({ type: IS_LOADING, status: isShowLoading, names: { REFERRAL_UPDATE: isShowLoading } });
  await axios.put(url, dataSet).then(response => {
    const resData = response.data;
    const { message } = resData;
    let status = 'success';
    if (resData.error || resData.errors) {
      status = 'error';
    }
    dispatch({ type: REFERRAL_UPDATE, playload: { status, message } });
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_UPDATE: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: REFERRAL_UPDATE, playload: { status: 'error' } });
    dispatch({ type: IS_LOADING, status: false, names: { REFERRAL_UPDATE: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const referralClear = () => dispatch => {
  dispatch({ type: REFERRAL_CLEAR });
};
